import { AxiosPromise } from 'axios';
import { AxiosClientFactory } from '../../../../common/helpers/AxiosClientFactory';
import { InsuranceReadModel } from '../../models/InsuranceReadModel';

export const getInsurances = (personId: number | string): AxiosPromise<InsuranceReadModel[]> => {
    return AxiosClientFactory
        .getInstance()
        .get<InsuranceReadModel[]>(`/api/applicants/${personId}/insurances`);
};
